module.exports = __webpack_public_path__ + "static/img/logo.6be89611.png";